//import { environment } from "src/environments/environment";

import studyTemplateJson_mdrtraining from './../../app/constants/json-files/mdrtraining.json';
import studyTemplateJson_mdrautomation from './../../app/constants/json-files/mdrautomation.json';
import studyTemplateJson_mdrimagequality from './../../app/constants/json-files/mdrimagequality.json';

import studyTemplateJson_ree from './../../app/constants/json-files/ree.json';
import studyTemplateJson_cancercolon from './../../app/constants/json-files/cancercolon.json';
import studyTemplateJson_cancergastrico from './../../app/constants/json-files/cancergastrico.json';
import studyTemplateJson_trifasico from './../../app/constants/json-files/trifasico.json';
import studyTemplateJson_trifasicov2 from './../../app/constants/json-files/trifasicov2.json';
import studyTemplateJson_valonc from './../../app/constants/json-files/valonc.json';
import studyTemplateJson_valor from './../../app/constants/json-files/valor.json';
import studyTemplateJson_onco12o from './../../app/constants/json-files/onco12o.json';
import studyTemplateJson_abbottcolonhmb from './../../app/constants/json-files/abbottcolonhmb.json';
import studyTemplateJson_obesidad from './../../app/constants/json-files/obesidad.json';
import studyTemplateJson_cancerovario from './../../app/constants/json-files/cancerovario.json';
import studyTemplateJson_cancerovariov2 from './../../app/constants/json-files/cancerovariov2.json';
import studyTemplateJson_cancermamasr from './../../app/constants/json-files/cancermamasr.json';
import studyTemplateJson_cancermamasr2 from './../../app/constants/json-files/cancermamasr2.json';
import studyTemplateJson_mucositissr from './../../app/constants/json-files/mucositissr.json';
import studyTemplateJson_pantheia from './../../app/constants/json-files/pantheia.json';
import studyTemplateJson_pantheiav2 from './../../app/constants/json-files/pantheiav2.json';
// TODO: These need to be reviewed
import studyTemplateJson_flash from './../../app/constants/json-files/flash.json';
import studyTemplateJson_flashv2 from './../../app/constants/json-files/flashv2.json';
import studyTemplateJson_fisobesidad from './../../app/constants/json-files/fisobesidad.json';
import studyTemplateJson_automaticdb from './../../app/constants/json-files/automaticdb.json';
import studyTemplateJson_compactgc from './../../app/constants/json-files/compactgc.json';
import studyTemplateJson_cutoffsvhir from './../../app/constants/json-files/cutoffsvhir.json';
import studyTemplateJson_torax from './../../app/constants/json-files/torax.json';
import studyTemplateJson_ectalent from './../../app/constants/json-files/ectalent.json'
import studyTemplateJson_plantology from './../../app/constants/json-files/plantology.json'
import studyTemplateJson_ccvhio from './../../app/constants/json-files/ccvhio.json'


//import studyTemplateJson_cancermamasr from './../../app/constants/json-files/test.json';

export const GlobalConstant = {
    fileLimitPerSingleZip: 2500,
    fileDownloadingConcurrency: 8,  // 5 debería ser aceptado por todos los navegadores
    fileUploadingConcurrency: 10,  // 5 debería ser aceptado por todos los navegadores
    defaultLanguage: 'en',
    allowBadlyAnonimizedDcm_Patient: true,
    allowBadlyAnonimizedDcm_Study: false,
    allowBadlyAnonimizedDcm_Series: false,
    badlyAnonymizedId: 'Incorrectly anonymized',
    studies: {
        mdrtraining: {
            template: studyTemplateJson_mdrtraining,
            name: 'MDR Training'
        }, 
        mdrautomation: {
            template: studyTemplateJson_mdrautomation,
            name: 'MDR Automation'
        },
        mdrimagequality: {
            template: studyTemplateJson_mdrimagequality,
            name: 'MDR Image Quality'
        },
        cancercolon: {
            template: studyTemplateJson_cancercolon,
            name: 'Cancer de colon',
        }, 
        cancergastrico: {
            template: studyTemplateJson_cancergastrico,
            name: 'Cancer gástrico'
        }, 
        ree: {
            template: studyTemplateJson_ree,
            name: 'Resting Energy Expenditure'
        }, 
        trifasico: {
            template: studyTemplateJson_trifasico,
            name: 'Trifásico'
        },
        trifasicov2: {
            template: studyTemplateJson_trifasicov2,
            name: 'Trifásico V2'
        }, 
        valonc: {
            template: studyTemplateJson_valonc,
            name: 'VALONC'
        },
        valor: {
            template: studyTemplateJson_valor,
            name: 'VALOR'
        },
        onco12o: {
            template: studyTemplateJson_onco12o,
            name: 'Onco 12 de Octubre'
        }, 
        abbottcolonhmb: {
            template: studyTemplateJson_abbottcolonhmb,
            name: 'Abbott colom HMB'
        },
        obesidad: {
            template: studyTemplateJson_obesidad,
            name: 'Obesidad'
        },
        cancerovario: {
            template: studyTemplateJson_cancerovario,
            name: 'Cancer de ovario'
        },
        cancerovariov2: {
            template: studyTemplateJson_cancerovariov2,
            name: 'Cancer de ovario ERAS'
        },
        cancermamasr: {
            template: studyTemplateJson_cancermamasr,
            name: 'Cancer de mama (SR)'
        },
        cancermamasr2: {
            template: studyTemplateJson_cancermamasr2,
            name: 'Cancer de mama (SR2)'
        },
        mucositissr: {
            template: studyTemplateJson_mucositissr,
            name: 'Mucositis (SR)'
        },
        pantheia: {
            template: studyTemplateJson_pantheia,
            name: 'Estudio Phanteia'
        },
        pantheiav2: {
            template: studyTemplateJson_pantheiav2,
            name: 'Estudio Phanteia V2'
        },
        flash: {
            template: studyTemplateJson_flash,
            name: 'Estudio FLASH'
        },
        flashv2: {
            template: studyTemplateJson_flashv2,
            name: 'Estudio FLASH (VHIR)'
        },
        fisobesidad: {
            template: studyTemplateJson_fisobesidad,
            name: 'FIS Obesidad'
        },
        automaticdb: {
            template: studyTemplateJson_automaticdb,
            name: 'Automatic DB'
        },
        compactgc: {
            template: studyTemplateJson_compactgc,
            name: 'COMPACT-GC'
        },
        cutoffsvhir: {
            template: studyTemplateJson_cutoffsvhir,
            name: 'Cutoffs VHIR'
        },
        torax: {
            template: studyTemplateJson_torax,
            name: 'Torax'
        },
        ectalent: {
            template: studyTemplateJson_ectalent,
            name: 'EC Talent'
        },
        plantology: {
            template: studyTemplateJson_plantology,
            name: 'Plantology'
        },
        ccvhio: {
            template: studyTemplateJson_ccvhio,
            name: 'CC VHIO'
        },
    },
    firestore: {
        collection_authorizedUsers: 'authorizedUsers',
        collection_patientId: 'patientId',
        collection_stableInfo: 'stable',
        collection_updatedInfo: 'update',
        collection_synchronizationInfo: 'synchronization',
        collection_excelInfo: 'excel',
        document_excelInfo: 'excelInfo',
        limit_numberOfDicomFilesInMainDict: 10,
        key_largeDocumentMovedToStorage: 'largeDocument',
        key_largeDocumentFileName: 'files.json'
    },
    formField: {
        textField: {
            maxLength: 50, 
            addmittedCharacters: /^[a-zA-Z0-9\t\n ./<>¿?;:"'`¡!@#$%^&*()\[\]{}_+=ºªñÑ,·çüÜ|\\-áéíóúÁÉÍÓÚ]*$/,
        },
    },
    study:{
        addmittedCharacters: /^[a-zA-Z0-9_]*$/,
    },
    dicom: {
        filenamesToAvoid: [ // Files to avoid
            'DICOMDIR', 
            '.DS_Store', 
            '._.DS_Store'],
        dicomKeysToKept: [ // DICOM metadata to be kept when anonymizing the images
            '_vrMap',
            'SOPClassUID',  
            'TransferSyntaxUID',
            'ImageType', 
            'Modality',
            'StudyDate',
            'SliceThickness', 
            'PixelSpacing', 
            'SeriesNumber', 
            'ImagePositionPatient',
            'ImageOrientationPatient',
            'PatientPosition',
            'Rows', 
            'Columns', 
            'BitsAllocated', 
            'BitsStored', 
            'RescaleIntercept', 
            'RescaleSlope', 
            'HighBit', 
            'PixelRepresentation', 
            'SmallestImagePixelValue', 
            'LargestImagePixelValue',
            'PhotometricInterpretation',
            'PatientSex', 
            'PatientAge', 
            'PatientWeight',
            'PatientSize',
            'PixelData',
            'SamplesPerPixel', 
            'RescaleType',
            'SpacingBetweenSlices',
            // Additional metadata to be used for software validation
            //  Adquisition parameters for software validation
            'SoftwareVersions', 'ConvolutionKernel', 'KVP', 'XRayTubeCurrent', 'ExposureTime',
            // Manufacturer parameters for software validation     
            'Manufacturer', 'ManufacturerModelName', 
            // Contrast parameters
            'ContrastBolusRoute', 'ContrastBolusAgent',
          ],
        dicomKeysToModify: [ // DICOM metadata to be modified when pseudonymizing the images
            'PatientID',
            'StudyID',
            // Unique ids for being able to manage the data --- TODO: Validate this ----
            'StudyInstanceUID', 'SeriesInstanceUID', 'SOPInstanceUID',
          ],
    },
    focusedonFileTypes: {
        bc_abd: ['.xlsx', '.pdf', '.fcsdn'],
        bc_abd_3d: ['.xlsx', '.pdf', '.fcsdn'],
        bc_neck: ['.xlsx', '.pdf', '.fcsdn'],
        trifasico: ['.xlsx', '.pdf', '.fcsdn'],
    },
}


     
